var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-blue-lighter",attrs:{"id":"app"}},[(!_vm.isBookingComplete)?_c('Booking',{attrs:{"init-data":_vm.initData},on:{"bookingCompleted":_vm.bookingCompleted}}):_c('ThankYou',{attrs:{"booking-data":_vm.bookingData,"init-data":_vm.initData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }